import styled from "styled-components";
import kamShop from "../../../assets/KamShop.png";
import kamShopv2 from "../../../assets/kamshopv2.png";
import EcommerceTechIcons from "./EcommerceTechIcons";
import EcommerceDescription from "./EcommerceDescription";
import ProjectBtns from "../ProjectBtns";

export default function EcommerceShop() {
  return (
    <ProjectContainer>
      <ProjectDesc>
        <h2>E-commerce Shop - Redux</h2>
        <p>
          This application is developed using Next.js and React, leveraging
          Redux for efficient state management. The development process is
          focused on atomic design principles. Data is fetched from a REST API
          to ensure dynamic and up-to-date content from dummyjson.com.
          Additionally, a few tests are implemented using Jest and React Testing
          Library.
        </p>
        <div>
          <Features>Used technologies:</Features>
          <EcommerceTechIcons />
        </div>
        <div>
          <Features>Features/Description</Features>
          <EcommerceDescription />
        </div>
      </ProjectDesc>
      <ProjectBtns>
        <button>
          <a
            href="https://ecommerce-redux-app-kw.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Try it live
          </a>
        </button>
        <button>
          <a
            href="https://github.com/Kamildeeal/ecommerce-redux-app.git"
            target="_blank"
            rel="noopener noreferrer"
          >
            View source
          </a>
        </button>
      </ProjectBtns>
      <Overview>
        <h2>Hover to see overview</h2>
        <div>
          <ProjectImageWrapper>
            <ProjectImage src={kamShopv2} alt="twitter_teaser" />
          </ProjectImageWrapper>
        </div>
      </Overview>
    </ProjectContainer>
  );
}

const ProjectDesc = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  & > p {
    margin-bottom: 20px;
  }

  & > h2 {
    color: rgba(240, 138, 230, 0.58);
  }
  & > h2,
  div {
    margin-bottom: 20px;

    @media (max-width: 460px) {
      margin-bottom: 10px;
    }
  }
`;

const ProjectContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  margin-top: 30px;
  margin-bottom: 80px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  overflow: hidden;
  color: white;
  padding: 10px 20px;
  transition: all 0.1s ease;

  &:hover {
    background: rgba(36, 36, 41, 0.87);
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
  @media (max-width: 460px) {
    margin-bottom: 16px;
  }
`;

const ProjectImageWrapper = styled.div`
  position: relative;
  width: 500px;
  height: 400px;
  overflow: hidden;
  border-radius: 8px;
  border: 2px solid black;

  &:hover img {
    transform: translateY(-53%);
  }
`;

const Overview = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;

  > h2 {
    margin-bottom: 10px;
  }

  @media (max-width: 1024px) {
    align-items: center;
    justify-content: center;
    > h2 {
      justify-content: center;
    }
  }
  @media (max-width: 670px) {
    display: none;
  }
`;

const ProjectImage = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 2s ease-in-out;
`;

const Features = styled.div`
  color: rgba(240, 138, 230, 0.58);
  font-weight: bold;
  margin-bottom: 0 !important;
`;
